<!--
 * @Author: ranjianglai
 * @Date: 2022-08-16 13:26:38
 * @LastEditTime: 2023-09-05 15:38:14
 * @Description: 首页
-->


<template>
    <div class="content">
        <!-- 实景展示 -->
        <section v-if="false && liveActionList.length" class="iframe">
            <el-carousel indicator-position="none" :autoplay="false">
                <el-carousel-item v-for="(item,index) in liveActionList" :key="index">
                    <iframe :id="'live-action'+index" class="vw-100 vh-100" :src="item.url" frameborder="0"></iframe>
                </el-carousel-item>
            </el-carousel>
            <div class="custom">
                <img width="50%" class="animate__animated animate__flipInX animate__delay-2s" :src="$config.welcomeImg" alt="" />
                <div style="margin-top:6rem">
                    <el-button v-if="false" @click="scorll" type="primary" plain class="animate__animated animate__flipInX">开始探索</el-button>
                    <el-button v-if="false" @click="goGroup" type="success" plain class="animate__animated animate__flipInX">集团官网</el-button>
                </div>
            </div>
        </section>
        <!-- 轮播图 -->
        <section class="carousel">
            <el-carousel indicator-position="none" :autoplay="false">
                <el-carousel-item v-for="(item,index) in bannerData.bannerList ? bannerData.bannerList : bannerList" :key="index">
                    <img :src="item" class="d-block vw-100 vh-100" alt="" />
                </el-carousel-item>
            </el-carousel>
            <div class="custom">
                <img width="50%" style="z-index: 100" class="animate__animated animate__flipInX animate__delay-2s" :src="$config.welcomeImg" alt="" />
                <div style="margin-top:6rem;z-index: 100;">
                    <el-button v-if="false" @click="scorll" type="primary" plain class="animate__animated animate__flipInX">开始探索</el-button>
                    <el-button v-if="false" @click="goGroup" type="success" plain class="animate__animated animate__flipInX">集团官网</el-button>
                </div>
            </div>
        </section>

        <!-- 热门活动 -->
        <section class="activity">
            <div class="container">
                <div class="com-flex com-row-between">
                    <h2 class="com-font-20 com-font-bold">热门活动</h2>
                    <div class="com-flex com-cursor-pointer" @click="skip('/activity')">
                        <span class="com-m-r-4 com-font-14 com-minor-color">查看更多</span>
                        <img src="@/static/right.png" width="15" height="15" alt="">
                    </div>
                </div>
                <div class="row">
                    <div v-for="(item,index) in hotActivityList" :key="index" class="col col-12 col-lg-6 col-xl-4">
                        <div class="item com-cursor-pointer" @mouseenter="activityCurrent=index" @mouseleave="activityCurrent=null">
                            <h5 class="com-font-18 com-font-bold com-line-1">{{item.title}}</h5>
                            <p class="com-m-t-14 com-font-12 com-minor-color">活动时间:{{item.startDate}}~{{item.endDate}}</p>
                            <img :class="['com-m-t-20',index==activityCurrent?'animate__animated animate__pulse':null]" :src="item.logo" width="100%"
                                style="height:25.5rem;object-fit:cover" alt="" />
                            <p class="com-m-t-20 com-font-14 com-line-2">{{item.introduce?item.introduce:'暂无活动简介'}}</p>
                            <div class="text-center">
                                <button type="button" class="com-m-t-24 btn btn-outline-secondary" @click="goActivityDetail(item.id)">了解更多</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="hotActivityList.length==0" class="w-100 com-flex com-row-center">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </div>
            </div>
        </section>

        <!-- 智游景区 -->
        <section class="play">
            <div class="h-100 container com-flex com-flex-col com-row-center">
                <h2 class="com-font-20 com-font-bold">智游景区</h2>
                <p class="com-m-t-30 com-font-14 text-center html" style="line-height:28px" v-html="play_text">
                </p>
                <div class="w-100 row">
                    <div v-for="(item,index) in plays" :key="index" @click="skip(item.path)" @mouseenter="playCurrent=index"
                        @mouseleave="playCurrent=null" class="col com-m-b-20 com-flex com-flex-col com-row-center com-cursor-pointer">
                        <img :src="item.icon" style="width:8rem;height:8rem"
                            :class="[index==playCurrent?'animate__animated animate__flipInY':null]" />
                        <span :class="['com-m-t-10 com-font-14',index==playCurrent?'animate__animated animate__flipInY':null]">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </section>

        <!-- 实景展播 -->
        <section class="liveAction">
            <div class="container">
                <div class="com-flex com-row-between">
                    <h2 class="com-font-20 com-font-bold">实景展播</h2>
                    <div v-if="liveActionList && liveActionList.length == 3" class="com-flex com-cursor-pointer"
                        @click="skip('/media/video?type=liveAction')">
                        <span class="com-m-r-4 com-font-14 com-minor-color">查看更多</span>
                        <img src="../static/right.png" width="15" height="15" alt="">
                    </div>
                </div>
                <div class="row">
                    <div v-for="(item,index) in liveActionList" :key="index" class="col col-12 col-lg-6 col-xl-4">
                        <div class="com-flex com-flex-col com-cursor-pointer item" @mouseenter="liveActionCurrent=index"
                            @mouseleave="liveActionCurrent=null" @click="externalLinks(item.url)">
                            <img :class="[index==liveActionCurrent?'animate__animated animate__flipInY':null]" :src="item.logo" width="100%"
                                style="object-fit:cover;height:28.5rem" alt="" />
                            <div class="w-100 com-line-1 text-left com-p-20 com-font-bold title">{{item.title}}</div>
                            <img class="play-icon" src="@/static/play.png" width="68" height="68" alt="" />
                        </div>
                    </div>
                    <div v-if="liveActionList.length==0" class="w-100 com-flex com-row-center">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </div>
            </div>
        </section>

        <!-- 友情链接 -->
        <section v-if="friendships && friendships.length" class="friendship">
            <div class="h-100 container com-flex com-flex-col">
                <h2 class="com-font-20 com-font-bold">友情链接</h2>
                <div class="row">
                    <div v-for="(item,index) in friendships" :key="index" class="col com-flex com-row-center com-cursor-pointer item"
                        @click="externalLinks(item.url)" @mouseenter="friendshipCurrent=index" @mouseleave="friendshipCurrent=null">
                        <img :class="[index==friendshipCurrent ? 'animate__animated animate__pulse' : null]" :src="item.logo" width="190"
                            height="68" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script>
import configData from "@/config/data.js";
import { liveActionList, hotActivity, linksList } from "@/request/api.js";
export default {
    name: "Home",
    components: {},
    props: {},

    data() {
        return {
            bannerList: [require('@/static/bg/h-general.png')],
            bannerData: {},
            // 热门活动
            hotActivityList: [],
            activityCurrent: null,
            // 智游景区
            play_text: configData.play_text,
            plays: [
                { icon: require("@/static/home/play1.png"), name: `游在${this.$config.name}`, path: "/list?type=SPOT" },
                { icon: require("@/static/home/play2.png"), name: `住在${this.$config.name}`, path: "/list?type=HOTEL" },
                { icon: require("@/static/home/play3.png"), name: `吃在${this.$config.name}`, path: "/list?type=DINING" },
                { icon: require("@/static/home/play4.png"), name: `购在${this.$config.name}`, path: "/list?type=SHOPPING" },
                { icon: require("@/static/home/play5.png"), name: `娱在${this.$config.name}`, path: "/list?type=RECREATION" },
            ],
            playCurrent: null,
            // 实时展播
            liveActionList: [],
            liveActionCurrent: null,
            // 友情链接
            friendships: [],
            friendshipCurrent: null,
        }
    },

    computed: {},
    watch: {},

    created() { },
    mounted() {
        // 设置banner
        this.setBanner();
        // 热门活动
        this.getHotActivity();
        // 实景展播列表
        this.getLiveActionList();
        // 友情链接
        this.getLinksList();
    },

    methods: {
        // 设置banner
        setBanner() {
            const list = JSON.parse(sessionStorage.getItem("MODULELIST"));
            list.map(v => {
                if (v.route == this.$route.path) this.bannerData = v;
            })
        },

        // 热门活动
        getHotActivity() {
            this.hotActivityList = [];
            hotActivity().then(res => {
                console.log("热门活动", res);
                res.map((v, i) => {
                    if (i < 3) this.hotActivityList.push(v);
                })
            })
        },

        // 实景展播
        getLiveActionList() {
            liveActionList().then(res => {
                console.log("实景展播", res);
                this.liveActionList = [];
                if (res && res.length) {
                    res.map((v, i) => {
                        if (i < 3) this.liveActionList.push(v);
                    })
                }
            })
        },

        // 友情链接
        getLinksList() {
            this.friendships = [];
            linksList().then(res => {
                console.log("友情链接", res);
                if (res && res.length) {
                    this.friendships = res;
                }
            })
        },


        // 跳转
        skip(path) {
            this.$router.push(path);
        },
        // 去活动详情页
        goActivityDetail(id) {
            this.$router.push({
                path: "/list/detail",
                query: {
                    type: "ACTIVITY",
                    id: id
                }
            })
        },
        // 友情链接
        externalLinks(url) {
            if (url) {
                window.open(url)
            } else {
                this.$notify({ type: "warning", message: "暂无外部链接地址" })
            }
        },


        // 页面滚动
        scorll() {
            $("body,html").animate({
                scrollTop: document.documentElement.clientHeight + 10
            }, 300)
        },

        // 去集团官网(兴文)
        goGroup() {
            location.href = "https://xwshtxq.com/#/index";
        }
    }
}
</script>


<style scoped lang="scss">
.iframe,
.carousel {
    position: relative;
    overflow: hidden;
    .custom {
        position: absolute;
        // width: 100%;
        // height: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
}
/* 热门活动 */
.activity {
    padding: 6rem 0;
    .row {
        margin-top: 3rem;
        .item {
            background: #eeeeee;
            padding: 3.5rem 3rem;
            transition: background 0.6s;
            border-radius: 6px;
            img {
                border-radius: 6px;
            }
            &:hover {
                background: var(--theme);
                color: var(--white);
                p {
                    color: var(--white);
                }
                .btn {
                    border: 1px solid var(--white);
                    color: var(--white);
                }
            }
            .btn {
                font-size: 14px;
                padding: 8px 16px;
            }
        }
    }
}
/* 智游景区 */
.play {
    height: 590px;
    background: url("../static/state/play-bg.png") no-repeat center center;
    background-size: cover;
    color: var(--white);
    .row {
        margin-top: 6rem !important;
    }
}
/* 实景展播 */
.liveAction {
    padding: 6rem 0;
    .row {
        .item {
            margin-top: 3rem;
            position: relative;
            .title {
                background: #eeeeee;
                transition: background 0.5s;
            }
            .play-icon {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -34px !important;
                margin-top: -64px !important;
                z-index: 100;
            }
            &:hover {
                .title {
                    background: var(--theme);
                    color: var(--white);
                }
            }
        }
    }
}
/* 友情链接 */
.friendship {
    width: 100%;
    height: 590px;
    background: url("../static/state/friendship-bg.png") no-repeat center center;
    background-size: cover;
    .container {
        // margin-top: -8rem;
        padding-bottom: 10rem !important;
        justify-content: flex-end;
        .row {
            margin-top: 5rem !important;
            .item {
                margin-top: 3rem;
            }
        }
    }
}
</style>
<style>
/* 轮播 */
.el-carousel__container {
    height: 100vh !important;
}
</style>